import {useCallback} from "react";

import {useIsMounted} from "@pg-mono/hooks";
import {SiteSlug} from "@pg-mono/km-routes";

import {appendCookieConsent} from "../utils/append_cookie_consent";
import {getFullKMLink} from "../utils/get_full_km_link";

/**
 * Decorates an already built KM url with the cookie consent.
 * The consent is appended only after mount - the cookie is not available during SSR,
 * so decorating it right away would make the server and the client markup differ.
 */
export const useKMLinkDecorator = () => {
    const isMounted = useIsMounted();

    return useCallback((url: string) => (isMounted ? appendCookieConsent(url) : url), [isMounted]);
};

/**
 * Builds a KM link for the RP site, decorated with the cookie consent - see `useKMLinkDecorator`.
 * Takes the route builder (`kmAppLink.site.*WithParams`) so the RP site slug stays in `getFullKMLink`
 * instead of being repeated at every call site.
 *
 * Being a hook, it can only be called during render. To build a link inside a callback, use
 * `useKMLinkDecorator` together with `getFullKMLink`.
 */
export const useKMLink = (getPath: (params: {site: SiteSlug}) => string) => {
    const decorateKMLink = useKMLinkDecorator();

    return decorateKMLink(getFullKMLink(getPath));
};
import {useCallback} from "react";

import {useIsMounted} from "@pg-mono/hooks";
import {SiteSlug} from "@pg-mono/km-routes";

import {appendCookieConsent} from "../utils/append_cookie_consent";
import {getFullKMLink} from "../utils/get_full_km_link";

/**
 * Decorates an already built KM url with the cookie consent.
 * The consent is appended only after mount - the cookie is not available during SSR,
 * so decorating it right away would make the server and the client markup differ.
 */
export const useKMLinkDecorator = () => {
    const isMounted = useIsMounted();

    return useCallback((url: string) => (isMounted ? appendCookieConsent(url) : url), [isMounted]);
};

/**
 * Builds a KM link for the RP site, decorated with the cookie consent - see `useKMLinkDecorator`.
 * Takes the route builder (`kmAppLink.site.*WithParams`) so the RP site slug stays in `getFullKMLink`
 * instead of being repeated at every call site.
 *
 * Being a hook, it can only be called during render. To build a link inside a callback, use
 * `useKMLinkDecorator` together with `getFullKMLink`.
 */
export const useKMLink = (getPath: (params: {site: SiteSlug}) => string) => {
    const decorateKMLink = useKMLinkDecorator();

    return decorateKMLink(getFullKMLink(getPath));
};
